/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Night_PluralInputs */

const en_rental_night_plural = /** @type {(inputs: Rental_Night_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nights`)
};

const es_rental_night_plural = /** @type {(inputs: Rental_Night_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`noches`)
};

const fr_rental_night_plural = /** @type {(inputs: Rental_Night_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nuits`)
};

const de_rental_night_plural = /** @type {(inputs: Rental_Night_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nächte`)
};

const id_rental_night_plural = /** @type {(inputs: Rental_Night_PluralInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`malam`)
};

/** @type {(inputs: Rental_Night_PluralInputs) => LocalizedString} */
const ja_rental_night_plural = en_rental_night_plural;

/** @type {(inputs: Rental_Night_PluralInputs) => LocalizedString} */
const zh_rental_night_plural = en_rental_night_plural;

/** @type {(inputs: Rental_Night_PluralInputs) => LocalizedString} */
const ar_rental_night_plural = en_rental_night_plural;

/** @type {(inputs: Rental_Night_PluralInputs) => LocalizedString} */
const it_rental_night_plural = en_rental_night_plural;

/** @type {(inputs: Rental_Night_PluralInputs) => LocalizedString} */
const ru_rental_night_plural = en_rental_night_plural;

/** @type {(inputs: Rental_Night_PluralInputs) => LocalizedString} */
const pt_rental_night_plural = en_rental_night_plural;

/** @type {(inputs: Rental_Night_PluralInputs) => LocalizedString} */
const ko_rental_night_plural = en_rental_night_plural;

/**
* | output |
* | --- |
* | "nights" |
*
* @param {Rental_Night_PluralInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_night_plural = /** @type {((inputs?: Rental_Night_PluralInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Night_PluralInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_night_plural(inputs)
	if (locale === "es") return es_rental_night_plural(inputs)
	if (locale === "fr") return fr_rental_night_plural(inputs)
	if (locale === "de") return de_rental_night_plural(inputs)
	if (locale === "ja") return ja_rental_night_plural(inputs)
	if (locale === "zh") return zh_rental_night_plural(inputs)
	if (locale === "ar") return ar_rental_night_plural(inputs)
	if (locale === "id") return id_rental_night_plural(inputs)
	if (locale === "it") return it_rental_night_plural(inputs)
	if (locale === "ru") return ru_rental_night_plural(inputs)
	if (locale === "pt") return pt_rental_night_plural(inputs)
	return ko_rental_night_plural(inputs)
});